export enum Period {
	YTD = 'YTD',
	LTM = 'LTM',
	PY = 'MONTH',
	FULL_YEAR = 'FULLYEAR',
}

export enum LowerPeriod {
	LTM = 'ltm',
	YTD = 'ytd',
	PY = 'month',
	FULL_YEAR = 'fullYear',
	YTD_AGENT_PROFILE = 'ytdAgentProfile',
	L5Y = 'l5y',
}

export enum GraphType {
	REVENUE_V3 = 'revenueV3',
	REVENUE_NEW = 'revenueNew',
	REVENUE_OLD = 'revenueOld',
	CLOSED = 'closed',
	OPENED = 'opened',
	PROSPECT_PROFILE = 'prospectProfile',
	BREAKDOWN_LTM = 'breakdownLTM',
	BREAKDOWN_YTD = 'breakdownYTD',
	LISTINGS_BREAKDOWN = 'listingsBreakdown',
	COMPARISON_GRAPH = 'comparisonGraph',
	TRANSACTIONS_BREAKDOWN = 'transactionsBreakdown',
	AGENT_RETENTION = 'agentRetention',
}

export enum MonthAbbreviationsDefault {
	Jan = 'Jan',
	Feb = 'Feb',
	Mar = 'Mar',
	Apr = 'Apr',
	May = 'May',
	Jun = 'Jun',
	Jul = 'Jul',
	Aug = 'Aug',
	Sep = 'Sep',
	Oct = 'Oct',
	Nov = 'Nov',
	Dec = 'Dec',
}

export enum MonthAbbreviationsNumeric {
	M1 = '1',
	M2 = '2',
	M3 = '3',
	M4 = '4',
	M5 = '5',
	M6 = '6',
	M7 = '7',
	M8 = '8',
	M9 = '9',
	M10 = '10',
	M11 = '11',
	M12 = '12',
}

export enum SeriesSetType {
	bar = 'bar',
	line = 'line',
}

export enum SeriesSetLabel {
	Closed = 'Closed',
	Pending = 'Pending',
	Opened = 'Opened',
	LastYear = 'Prior year',
	OtherRevenue = 'Other revenue',
	Benchmark = 'Benchmark',
	YourGoal = 'Your goal',
}

export enum SeriesSetStack {
	open = 'open',
	closed = 'closed',
	pending = 'pending',
	otherRevenue = 'otherRevenue',
	lastYear = 'lastYear',
	benchmark = 'benchmark',
	yourGoal = 'yourGoal',
}

export enum SeriesSetStackTitle {
	open = 'Opened',
	closed = 'Closed',
	pending = 'Pending',
}

export enum ChartScaleType {
	band = 'band',
	linear = 'linear',
}

export enum BiTabType {
	Gci,
	Sides,
	SalesVolume,
}

export enum BiMetricType {
	Gci = 'GCI',
	Sides = 'Sides',
	SalesVolume = 'Sales volume',
}

export enum SegmentType {
	YTD,
	LTM,
	PY,
}

export enum SidesTransactionType {
	both,
	buy,
	sell,
}

export enum Notation {
	compact = 'compact',
	standard = 'standard',
}

export enum IndicatorIcons {
	up = 'up',
	down = 'down',
	flat = 'flat',
	pending = 'pending',
	closed = 'closed',
}
export enum MetricKeysDataPoint {
	openNo = 'openNo',
	closedNo = 'closedNo',
	pendingNo = 'pendingNo',
	prevOpenNo = 'prevOpenNo',
	prevClosedNo = 'prevClosedNo',
	otherRevenueClosedNo = 'otherRevenueClosedNo',
	prevOtherRevenueClosedNo = 'prevOtherRevenueClosedNo',
	benchmarkClosedNo = 'benchmarkClosedNo',
	benchmarkOpenNo = 'benchmarkOpenNo',
}
export enum BenchmarkScale {
	LessThan1M = 'lessThan1M',
	Upto5M = 'upto5M',
	Upto10M = 'upto10M',
	Upto20M = 'upto20M',
	MoreThan20M = 'moreThan20M',
	Unknown = 'unknown',
}

export enum BenchmarkScaleParam {
	LessThan1M = '0M',
	Upto5M = '1M',
	Upto10M = '5M',
	Upto20M = '10M',
	MoreThan20M = '20M',
	Unknown = 'UNK',
}

export enum GranularityParam {
	Month = 'MONTH',
	Year = 'YEAR',
}

export enum LineStyle {
	solid = 'solid',
	dashed = 'dashed',
}

export enum LegendShape {
	circle = 'circle',
	rect = 'rect',
	line = 'line',
	dashedLine = 'dashedLine',
}

export enum TimePeriod {
	LTM = 'LTM',
	YTD = 'YTD',
	L5Y = 'L5Y',
}
export enum TimePeriodId {
	LTM = 0,
	YTD = 1,
	L5Y = 2,
}
export enum MetricsConfigChart {
	GCI = 'GCI', //'gci',
	SIDES = 'SIDES', //'sides',
	SALES_VOLUME = 'TRXAM', //'sales_volume',
	AVERAGE_BROKER_COMMISSION_RATE = 'ABCR', //'average_broker_commission_rate',
	AVERAGE_SALE_PRICE = 'AVGSALEAM', //'average_sale_price',
	TRANSACTION_COUNT = 'TRXCT', //'transaction_count',
}
export enum apiTransactionKeyMetrics {
	GCI = 'GCI',
	SIDES = 'SIDES',
	SALES_VOLUME = 'TRXAM',
	AVERAGE_BROKER_COMMISSION_RATE = 'ABCR',
	AVERAGE_SALE_PRICE = 'AVGSALEAM',
	TRANSACTION_COUNT = 'TRXCT',
}
export enum TransactionSeriesSetStack {
	open = 'OPND',
	closed = 'CLOS',
	pending = 'PEND',
}

export enum TransactionSeriesSetStackTitle {
	OPND = 'Opened',
	CLOS = 'Closed',
	PEND = 'Pending',
}

export enum EmptyStateVariant {
	Default = 'default',
	Medium = 'medium',
	Small = 'small',
}

// Transaction Details API Enums
export enum TransactionStatusCd {
	PENDING = 'PEND',
	CLOSED = 'CLOS',
	CANCELLED = 'CNCL',
	CONTRACT = 'CNTR',
}
export enum TransactionStatusCdLabel {
	PEND = 'Pending',
	CLOS = 'Closed',
}
export enum ListingsSortCd {
	LISTED_DATE_ASC = '+listedDt',
	LISTED_DATE_DESC = '-listedDt',
	LISTING_STATUS_ASC = '+listingStatusCd',
	LISTING_STATUS_DESC = '-listingStatusCd',
	AGENT_NAME_ASC = '+composedAgentNm',
	AGENT_NAME_DESC = '-composedAgentNm',
	LIST_PRICE_ASC = '+listPriceAm',
	LIST_PRICE_DESC = '-listPriceAm',
	OFF_MARKET_DATE_ASC = '+offMarketDt',
	OFF_MARKET_DATE_DESC = '-offMarketDt',
}
export enum TransactionSortCd {
	CONTRACT_DATE_ASC = '+contractDt',
	CONTRACT_DATE_DESC = '-contractDt',
	TRANSACTION_STATUS_ASC = '+transactionStatusCd',
	TRANSACTION_STATUS_DESC = '-transactionStatusCd',
	AGENT_NAME_ASC = '+composedAgentNm',
	AGENT_NAME_DESC = '-composedAgentNm',
	ESTIMATED_CLOSE_DATE_ASC = '+estimatedCloseDt',
	ESTIMATED_CLOSE_DATE_DESC = '-estimatedCloseDt',
	CLOSE_DATE_ASC = '+closeDt',
	CLOSE_DATE_DESC = '-closeDt',
	SALE_PRICE_ASC = '+salePriceAm',
	SALE_PRICE_DESC = '-salePriceAm',
	BROKER_COMMISSION_RATE_ASC = '+avgBrokerCommissionRt',
	BROKER_COMMISSION_RATE_DESC = '-avgBrokerCommissionRt',
}

export enum DateRangeCd {
	CONTRACT = 'CNTR',
	CANCEL = 'CNCL',
	ESTIMATED_CLOSE = 'ECLS',
	CLOSE = 'CLOS',
	LISTED = 'listedDt',
	OFF_MARKET = 'offMarketDt',
}

export enum PartyTypeCd {
	AGENT = 'AGENT',
	BROKER = 'BROKER',
	OFFICE = 'OFFICE',
}

export enum ActivityGroupCd {
	NOTE = 'NOTE',
	TODO = 'TODO',
	EVENT = 'EVENT',
	LOG = 'LOG',
}
